<div>
  <adm-steps [steps]="stepNames" [current]="step + 1"></adm-steps>

  <div *ngIf="previewing" style="margin: 10px 0"><i class="fas fa-spinner fa-pulse"></i> Working out what would change...</div>
  <div *ngIf="previewError" class="alert alert-danger">
    {{ previewError }}
    <div style="margin-top: 8px"><button mat-stroked-button (click)="backToStart()">Back</button></div>
  </div>

    <!-- PREVIEW -->
    <div *ngIf="step === 0 && plan">
      <div style="margin-bottom: 10px">
        <span class="badge badge-success" style="font-size: 100%; margin-right: 6px">{{ plan.created }} to create</span>
        <span class="badge badge-primary" style="font-size: 100%; margin-right: 6px">{{ plan.updated }} to update</span>
        <span class="badge badge-warning" style="font-size: 100%; margin-right: 6px" *ngIf="plan.guarded > 0">{{ plan.guarded }} guarded</span>
        <span class="badge badge-secondary" style="font-size: 100%; margin-right: 6px">{{ plan.unchanged }} unchanged</span>
        <span class="badge badge-danger" style="font-size: 100%" *ngIf="plan.blocked > 0">{{ plan.blocked }} blocked</span>
      </div>

      <div *ngIf="plan.documentProblems && plan.documentProblems.length > 0" class="alert alert-danger">
        <b>Problems with the file</b>
        <div *ngFor="let p of plan.documentProblems">{{ p }}</div>
      </div>
      <div *ngIf="plan.newIssues && plan.newIssues.length > 0" class="alert alert-danger">
        <b>This import would make the definition invalid</b> (these errors are new, they are not there today):
        <div *ngFor="let i of plan.newIssues"><span class="text-muted">{{ i.code }}</span> {{ i.subject }}: {{ i.message }}</div>
      </div>
      <div *ngIf="plan.blocked === 0 && plan.updated === 0 && plan.created === 0" class="alert alert-info">
        Nothing to do: everything in the file already matches this environment.
      </div>
      <div *ngIf="plan.guarded > 0 && plan.canApply" class="alert alert-warning">
        {{ plan.guarded }} item(s) change something that existing ADMs, Groups or customers may depend on. You will be asked to acknowledge each one before anything is applied.
      </div>

      <div class="row" style="margin-bottom: 6px">
        <div class="col-md-3">
          <mat-form-field class="full-width">
            <mat-label>Show</mat-label>
            <mat-select [(value)]="actionFilter">
              <mat-option value="changes">Changes only</mat-option>
              <mat-option value="guarded">Guarded changes</mat-option>
              <mat-option value="blocked">Blocked</mat-option>
              <mat-option value="all">Everything</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field class="full-width">
            <mat-label>Search</mat-label>
            <input matInput [(ngModel)]="itemSearch" autocomplete="off" />
          </mat-form-field>
        </div>
        <div class="col-md-5" style="margin-top: 10px">
          <button mat-stroked-button (click)="expandAll(true)">Expand all</button>&nbsp;
          <button mat-stroked-button (click)="expandAll(false)">Collapse all</button>&nbsp;
          <button mat-stroked-button (click)="downloadReport()"><i class="fas fa-download"></i> Report</button>
        </div>
      </div>

      <p *ngIf="visibleCount === 0" class="text-muted">Nothing matches this filter.</p>

      <ng-container *ngFor="let type of types">
        <div *ngIf="itemsOfType(type.value).length > 0" style="margin-bottom: 14px">
          <h6 style="margin-bottom: 4px">
            {{ type.label }}
            <span class="text-muted" style="font-weight: normal">
              ({{ countOfType(type.value, 'Create') }} new, {{ countOfType(type.value, 'Update') }} updated, {{ countOfType(type.value, 'Unchanged') }} unchanged<span *ngIf="countOfType(type.value, 'Blocked') > 0">, <span style="color: #b00020">{{ countOfType(type.value, 'Blocked') }} blocked</span></span>)
            </span>
          </h6>
          <table class="table table-sm" style="margin-bottom: 0">
            <ng-container *ngFor="let item of itemsOfType(type.value)">
              <tr (click)="toggleExpanded(item)" style="cursor: pointer">
                <td style="width: 24px"><i class="fas" [ngClass]="expanded.has(item.ackKey) ? 'fa-chevron-down' : 'fa-chevron-right'"></i></td>
                <td style="width: 90px"><span [class]="badgeClass(item.action)">{{ item.action }}</span></td>
                <td>
                  {{ item.key }}
                  <span *ngIf="item.hasGuardedChanges && item.action === 'Update'" class="badge badge-warning" style="margin-left: 6px">guarded</span>
                  <span *ngIf="item.table && item.type !== 'Table'" class="text-muted" style="margin-left: 6px; font-size: 85%">on {{ item.table }}</span>
                </td>
                <td class="text-muted" style="font-size: 90%">{{ impactText(item) }}</td>
              </tr>
              <tr *ngIf="expanded.has(item.ackKey)">
                <td></td>
                <td colspan="3" style="background: #fafafa">
                  <div *ngFor="let p of item.problems" style="color: #b00020"><i class="fas fa-times-circle"></i> {{ p }}</div>
                  <table class="table table-sm" *ngIf="item.changes && item.changes.length > 0" style="margin: 4px 0; background: transparent">
                    <tr><th style="width: 22%">Field</th><th style="width: 34%">Currently</th><th style="width: 34%">After import</th><th></th></tr>
                    <tr *ngFor="let c of item.changes">
                      <td>{{ c.field }}</td>
                      <td style="word-break: break-word"><span *ngIf="c.oldValue">{{ c.oldValue }}</span><span *ngIf="!c.oldValue" class="text-muted">(empty)</span></td>
                      <td style="word-break: break-word"><span *ngIf="c.newValue">{{ c.newValue }}</span><span *ngIf="!c.newValue" class="text-muted">(empty)</span></td>
                      <td><span *ngIf="c.guarded" class="badge badge-warning">guarded</span></td>
                    </tr>
                  </table>
                  <div *ngIf="item.action === 'Create'" class="text-muted">New: it does not exist here yet.</div>
                  <div *ngIf="item.action === 'Unchanged'" class="text-muted">Already matches the file.</div>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </ng-container>

      <div style="margin-top: 10px">
        <button mat-stroked-button (click)="backToStart()">Back</button>&nbsp;
        <button mat-raised-button class="piButton" (click)="goToConfirm()" [disabled]="!plan.canApply || (plan.created === 0 && plan.updated === 0)">Continue</button>
        <span *ngIf="!plan.canApply" class="text-muted" style="margin-left: 10px">Fix the blocked items and start again to continue.</span>
      </div>
    </div>

    <!-- CONFIRM -->
    <div *ngIf="step === 1 && plan">
      <p>
        This will create <b>{{ plan.created }}</b> and update <b>{{ plan.updated }}</b> item(s) in this environment, in a single step: if anything fails, nothing is changed.
        Nothing will be deleted.
      </p>

      <div *ngIf="guardedItems.length === 0" class="alert alert-success">No guarded changes: there is nothing to acknowledge.</div>

      <div *ngIf="guardedItems.length > 0">
        <div class="alert alert-warning">
          These changes overwrite existing values that ADMs, Groups or customers may rely on. Existing ADMs keep serving their current data until they are refreshed.
          Review each and tick it to acknowledge.
        </div>
        <mat-checkbox [checked]="allAcknowledged" (change)="acknowledgeAll($event.checked)"><b>Acknowledge all {{ guardedItems.length }}</b></mat-checkbox>
        <table class="table table-sm" style="margin-top: 6px">
          <tr *ngFor="let item of guardedItems">
            <td style="width: 34px; vertical-align: top">
              <mat-checkbox [checked]="acknowledged.has(item.ackKey)" (change)="toggleAcknowledged(item, $event.checked)"></mat-checkbox>
            </td>
            <td>
              <b>{{ item.key }}</b> <span class="text-muted">({{ item.type }})</span>
              <span *ngIf="impactText(item)" class="badge badge-warning" style="margin-left: 6px">{{ impactText(item) }}</span>
              <div *ngFor="let c of guardedChanges(item)" style="font-size: 90%">
                {{ c.field }}: <span class="text-muted">{{ c.oldValue || "(empty)" }}</span> &rarr; <b>{{ c.newValue || "(empty)" }}</b>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div *ngIf="needsTypedConfirmation" style="margin: 12px 0">
        <mat-form-field style="width: 320px">
          <mat-label>Type {{ confirmWord }} to confirm</mat-label>
          <input matInput [(ngModel)]="typedConfirmation" autocomplete="off" />
          <mat-hint>{{ guardedInUse.length }} of these items are in use.</mat-hint>
        </mat-form-field>
      </div>

      <div *ngIf="applyError" class="alert alert-danger" style="margin-top: 10px">{{ applyError }}</div>

      <div style="margin-top: 10px">
        <button mat-stroked-button (click)="back1()" [disabled]="applying">Back</button>&nbsp;
        <button mat-raised-button class="piButton" (click)="apply()" [disabled]="!canApply">Apply import</button>
        <span *ngIf="applying" style="margin-left: 10px"><i class="fas fa-spinner fa-pulse"></i> Applying...</span>
      </div>
    </div>

    <!-- RESULT -->
    <div *ngIf="step === 2 && result">
      <div class="alert alert-success">
        <b>Import applied.</b> {{ result.plan.created }} created, {{ result.plan.updated }} updated, {{ result.plan.unchanged }} already up to date. Nothing was deleted.
      </div>
      <div [style.color]="resultErrors.length > 0 ? '#b00020' : 'inherit'">
        The definition now has <b>{{ resultErrors.length }}</b> error(s) and <b>{{ resultWarnings.length }}</b> warning(s).
        <span class="text-muted" *ngIf="resultErrors.length > 0">(Errors that already existed are not caused by this import.)</span>
      </div>
      <div style="margin-top: 12px">
        <button mat-raised-button class="piButton" (click)="openValidation.emit()">View validation</button>&nbsp;
        <button mat-stroked-button (click)="finished.emit()">{{ finishLabel }}</button>
      </div>
    </div>
</div>
